import { GatsbyImage } from 'gatsby-plugin-image'
import React from 'react'
import { ITestimonial } from 'types'
import { prepareData } from 'utils/googleData'

function Quote({ children, direction, className = '' }: { children: React.ReactNode[]; className?: string }) {
    return (
        <div
            dir={direction}
            className={`-mx-5 grid gap-y-8 bg-gray-accent-light py-10 px-5 md:-mx-12 md:grid-cols-2 md:gap-y-0 md:gap-x-8 md:px-16 lg:gap-x-12 xl:gap-x-16 ${className}`}
        >
            <div>{children[0]}</div>
            <div className="-mt-16">{children[1]}</div>
        </div>
    )
}

export function Testimonial(props: ITestimonial) {
    const {
        enable,
        title,
        name,
        description,
        cta,
        direction,
        style = '',
        gatsbyImage,
        gatsbyImage2,
        gatsbyImage3,
        text,
        gatsbyImageSrc,
        gatsbyImage2Src,
        gatsbyImage3Src,
        size = 'lg',
    } = prepareData({ props })

    if (enable?.toLowerCase?.() === 'false' && !process.env.RENDER_DISABLED_COMPONENTS) {
        return <></>
    }

    return (
        <section direction={direction} className="mt-8">
            <Quote direction={direction} className="items-end">
                <div>
                    {gatsbyImage2Src && <img className="max-h-[45px] text-black" src={gatsbyImage2Src} />}
                    {text && <p className="my-6 text-[17px]" dangerouslySetInnerHTML={{ __html: text }} />}

                    <div className="flex items-center space-x-4">
                        {gatsbyImageSrc && <img className="max-w-[50px] rounded-full" src={gatsbyImageSrc} />}
                        <div>
                            {name && <p className="m-0 font-bold">{name}</p>}
                            {title && description && (
                                <p className="m-0 opacity-70">
                                    {title}, {description}
                                </p>
                            )}
                        </div>
                    </div>
                </div>
                <div>{gatsbyImage3 && <GatsbyImage alt="" image={gatsbyImage3} />}</div>
            </Quote>
        </section>
    )
}
export default Testimonial
